import { useNavigate } from 'react-router';
import {
    ContactModel,
    EmployeeModel,
    Project,
} from '../../../../domain/projects/project';
import { useEffect, useState } from 'react';
import { CreateProject } from '../../../../domain/projects/createProject';
import { ProjectsRepository } from '../../../../infrastructure/repositories/projects/projectRepository';
import { Private_Routes } from '../../../../main/constants';
import { UpdateProject } from '../../../../domain/projects/UpdateProject';
import FormErrorMessage from '../../../shared/components/forms/FormErrorMessage';
import { Link } from 'react-router-dom';
import ProjectDetailsSection from './ProjectDetailsSection';
import ProjectExecutionSection from './ProjectExecutionSection';
import FinancialInformationSection from './FinancialInformationSection';
import Swal from 'sweetalert2';

interface Props {
    isNewProject: boolean;
    project?: Project | null;
}

export const ProjectForm = ({ isNewProject, project: selectedProject }: Props) => {
    const initialState = selectedProject ?? {
        id: 0,
        productId: 0,
        productName: '',
        customerId: 0,
        customerName: '',
        cityId: 0,
        cityName: '',
        projectStatusId: 0,
        name: '',
        percentage: 0,
        startDate: '',
        endDate: '',
        realEndDate: null,
        scheduledDate: '',
        totalCost: 0,
        summary: '',
        customerContacts: [],
        employees: [],
    };

    const [project, setProject] = useState<Project>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isIncomplete, setIsIncomplete] = useState(true);

    const navigate = useNavigate();

    const handleInputChange = (
        name: string,
        value:
            | string
            | boolean
            | number[]
            | number
            | undefined
            | EmployeeModel[]
            | ContactModel[]
    ) => {
        setProject({ ...project, [name]: value });
    };

    const handleError = (error: any) => {
        setErrorMessage(error.response.data);
        setIsSubmitting(false);
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        setIsSubmitting(true);
        setErrorMessage('');

        if (isNewProject) {
            let body: CreateProject = {
                cityId: project.cityId,
                customerId: project.customerId,
                customerContactsIds: project.customerContacts.map((cc) => cc.id),
                employeeIds: project.employees.map((e) => e.id),
                productId: project.productId,
                name: project.name,
                startDate: project.startDate,
                endDate: project.endDate,
                scheduledDate:
                    project.scheduledDate === '' ? null : project.scheduledDate,
                percentage: project.percentage,
                projectStatusId: project.projectStatusId,
                totalCost: project.totalCost,
                summary: project.summary,
            };
            ProjectsRepository.CreateProject(body)

                .then((response) => {
                    navigate(Private_Routes.PROJECT_PAGE);
                    setIsSubmitting(false);
                    Swal.fire('Proyecto creado exitosamente!', '', 'success');
                })
                .catch(handleError);
        } else {
            let body: UpdateProject = {
                cityId: project.cityId,
                customerId: project.customerId,
                customerContactsIds: project.customerContacts.map((cc) => cc.id),
                employeeIds: project.employees.map((e) => e.id),
                productId: project.productId,
                name: project.name,
                startDate: project.startDate,
                endDate: project.endDate,
                realEndDate: project.realEndDate === '' ? null : project.realEndDate,
                scheduledDate:
                    project.scheduledDate === '' ? null : project.scheduledDate,
                percentage: project.percentage,
                projectStatusId: project.projectStatusId,
                totalCost: project.totalCost,
                summary: project.summary,
            };

            ProjectsRepository.UpdateProject(body, project.id)
                .then((response) => {
                    navigate(Private_Routes.PROJECT_PAGE);
                    setIsSubmitting(false);
                    Swal.fire('Proyecto actualizado exitosamente!', '', 'success');
                })
                .catch(handleError);
        }
    };

    useEffect(() => {
        if (
            project.name !== '' &&
            project.cityId > 0 &&
            project.customerId > 0 &&
            project.productId > 0 &&
            project.startDate !== undefined &&
            project.endDate !== undefined &&
            project.totalCost > 0
        ) {
            setIsIncomplete(false);
        } else {
            setIsIncomplete(true);
        }
    }, [project]);

    const onFiltersChange = (name: string, selectedIds: number[]) => {
        setProject({ ...project, [name]: selectedIds });
    };

    return (
        <div>
            <FormErrorMessage errorMessage={errorMessage} />
            <div className='row'>
                <div className='col-xxl-12'>
                    <div className='card '>
                        <div className='card-body p-4'>
                            <div className='row'>
                                <ProjectDetailsSection
                                    onFiltersChange={onFiltersChange}
                                    project={project}
                                    onChange={handleInputChange}
                                />
                                <ProjectExecutionSection
                                    isNewProject={isNewProject}
                                    project={project}
                                    onChange={handleInputChange}
                                />
                                <FinancialInformationSection
                                    isNewProject
                                    project={project}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex gap-2'>
                    <Link to={Private_Routes.PROJECT_PAGE} className='btn btn-withe'>
                        <i className='mdi mdi-arrow-left'></i> Atrás
                    </Link>

                    {isNewProject ? (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            {isSubmitting ? 'Creando...' : 'Crear'}
                        </button>
                    ) : (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            <i className='ri-arrow-up-circle-line'></i>
                            {isSubmitting ? 'Actualizando...' : 'Actualizar'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
